import $ from 'jquery';
import bootstrap from 'bootstrap';
import Swiper from 'swiper';
// import 'cookieconsent';

import { Navigation, Pagination, Autoplay } from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay])

//Solutions Image Slider
const solutionimageswiper = new Swiper('.solution__image-swiper--container', {
  slidesPerView: 1,
  autoplay: true,
  watchOverflow: true,
  navigation: {
    nextEl: '.solution__image-buttons-next',
    prevEl: '.solution__image-buttons-prev',
  },
  spaceBetween: 30,
});

//Solutions Text Slider
const solutiontextswiper = new Swiper('.solution__text-swiper--container', {
  slidesPerView: 1,
  autoplay: true,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  spaceBetween: 30,
});



//Testimonials Slider
const showcaseswiper = new Swiper('.testimonial__container', {
    slidesPerView: 1,
    // Navigation arrows
    navigation: {
      nextEl: '.testimonial__buttons-next',
      prevEl: '.testimonial__buttons-prev',
    },
    spaceBetween: 30,
    breakpoints: {
      1200: {
        slidesPerView: 1,
        spaceBetween: 0,
      }
    },
  });

//mobile menu toggle
document.getElementById('hamburgerToggle').onclick = () => {
    document.getElementById('hamburger').classList.toggle('is-active'),
    document.getElementById('mobileMenu').classList.toggle('header__mobile-menu--show')
  }

// Blog Filter 
  var f = new Filter({
    target: '.tags__tag',
    container: '#blogContainer',
    callback: function(container, response){
        /** IE doesn't treat response as an object - parse it as json if not already an object */
        var response = !response.posts ? JSON.parse(response) : response
        response.posts.forEach(function(item){
          console.log(item);
            
            let html = `<div class="col-12 col-md-6 mb-5 blog__single">
                <div class="blog__single-image">
                  <div class="blog__single-image-background" style="background-image: url(${item.post_thumbnail});"></div>
                </div>
                <div class="blog__single-inner">
                    <h3>${item.post_title}</h3>
                    <div class="blog__single-inner--date">${item.date}</div>

                    ${item.excerpt}<span><a href="${item.guid}"> Read More...</a></span>
                </div>
            </div>`;
            $(container).append(html);
        });
    },
    formDataCallback: function( data, items ) {
        if(items['category'] != undefined){
            data.append('category__in', items['category']);
        }
        data.append('post_status', 'publish');
        return data;
    },
    per_page: 6,
    initialRequest: true
});

$(function () {
  $('#menu-item-131 a').on("click", function () {
    gtag( 'event', { 'event_category': 'Contact page (header)', eventAction: 'CTA click', 'event_label': 'Contact page (header)', value: 1});
  })
});

document.querySelector('[href="#home__video--container"]')
        .addEventListener('click', (e) => {
            e.preventDefault();

            document.querySelector('.home__video--modal-container').classList.add('active');
            document.body.classList.add('no-scroll');

            if(window.player !== undefined){
              window.player.playVideo();
            }
        });

var element = document.querySelector('.home__video--modal-container');

if(element != null){
  element.addEventListener("click", (e) => {
		if (element.classList.contains("active")) {
			element.classList.remove("active");
			document.body.classList.remove("no-scroll");

			if (window.player !== undefined) {
				window.player.pauseVideo();
			}
		}
	});
}
        